import { z } from "zod";
import { flag, int, isoDate, lenientArray, optionalInt, optionalText, strings, text } from "./common";

export const transitPositionSchema = z.object({
  planet: text(),
  sign: text(),
  house_from_lagna: int(),
  retrograde: flag(),
  conjunct_natal: strings(),
});
export type TransitPosition = Readonly<z.output<typeof transitPositionSchema>>;

/** `GET /me/transits`: where the planets are now, relative to the chart. */
export const transitsSchema = z.object({
  at_utc: isoDate(),
  planets: lenientArray(transitPositionSchema),
  sade_sati: flag(),
  sade_sati_phase: optionalText(),
  saturn_house_from_moon: optionalInt(),
  jupiter_house_from_moon: optionalInt(),
});
export type Transits = Readonly<z.output<typeof transitsSchema>>;

export const remedySchema = z.object({
  kind: text(),
  text: text(),
});
export type Remedy = Readonly<z.output<typeof remedySchema>>;

/** `GET /me/remedies`: zero-cost remedies for the graha that needs them. */
export const remediesSchema = z.object({
  for_graha: text(),
  remedies: lenientArray(remedySchema),
  never_sold: flag(),
  note: text(),
});
export type Remedies = Readonly<z.output<typeof remediesSchema>>;
